
import { createRoot } from 'react-dom/client'
import { AppAuthProvider } from './auth/AppAuthProvider'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById("root")!).render(
  <AppAuthProvider>
    <App />
  </AppAuthProvider>
);
